import React from "react";

// Components imports
import Button from "../../../common/Button";

// Scss imports
import css from "./ChooseAccountType.module.scss";

interface ChooseAccountTypeProps {
  setAccountTypeToLegalEntity: Function;
  setAccountTypeToIndividual: Function;
  individualButtonRef: any;
  legalEntityButtonRef: any;
  buttonLegalClicked: boolean;
  buttonIndividualClicked: boolean;
  error: boolean;
  errorText: string;
}

const ChooseAccountType: React.FC<ChooseAccountTypeProps> = ({
  setAccountTypeToLegalEntity,
  setAccountTypeToIndividual,
  individualButtonRef,
  legalEntityButtonRef,
  buttonLegalClicked,
  buttonIndividualClicked,
  error,
  errorText
}) => {
  return (
    <div>
      {error && (
        <p className={css.errorText}>
          Изаберите један од понуђених типова налога
        </p>
      )}
      <p className={css.accountButtonsWrapper}>
        <Button
          text="Правно лице"
          onButtonClickHandler={setAccountTypeToLegalEntity}
          refButton={legalEntityButtonRef}
          buttonClicked={buttonLegalClicked}
        />
        <Button
          text="Физичко лице"
          onButtonClickHandler={setAccountTypeToIndividual}
          refButton={individualButtonRef}
          buttonClicked={buttonIndividualClicked}
        />
      </p>
    </div>
  );
};

export default ChooseAccountType;
